// @ts-ignore
import { type ApiResult } from "@utils/httpClientCore";
import { gaApiCall } from "@utils/httpClientCsrf";
// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { renderJsonWithNumbersAsBigint, parseJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import type * as schema from "@newgenerated/shared/schema";
import { serialize_QuickWinFeedback } from "@newgenerated/shared/serializerDeserializer/QuickWinFeedback";

export async function trackQuickWinFeedback(props: { body: schema.QuickWinFeedback; quickWinId: bigint }): Promise<ApiResult> {
  let path = "/gaapi/quickwins/{quickWinId}/feedback";
  path = path.replace(
    "{quickWinId}",
    ((value) => {
      return ((value) => {
        return value;
      })(
        (() => {
          return renderJsonWithNumbersAsBigint(
            (() => {
              return value;
            })(),
          );
        })(),
      );
    })(props.quickWinId),
  );
  const response = await gaApiCall({
    path: path,
    method: "POST",
    requestBody: ((value) => {
      return serialize_QuickWinFeedback(value);
    })(props.body),
  });
  if (response.kind == "error") {
    return response;
  }
  return { kind: "success" };
}
